import { render, staticRenderFns } from "./mt4InfoDialog.vue?vue&type=template&id=2977897b&scoped=true"
import script from "./mt4InfoDialog.vue?vue&type=script&lang=js"
export * from "./mt4InfoDialog.vue?vue&type=script&lang=js"
import style0 from "./mt4InfoDialog.vue?vue&type=style&index=0&id=2977897b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977897b",
  null
  
)

export default component.exports